import { render, staticRenderFns } from "./noPermission.vue?vue&type=template&id=2970572c&"
import script from "./noPermission.vue?vue&type=script&lang=js&"
export * from "./noPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports